module.exports = __webpack_public_path__ + "img/full4-min.9dc4a959.png";